<template>
    <div>
    <!--
    <div class="history" v-if="elementStepper">
        <md-steppers ref="step" md-vertical>
        <md-step
            v-for="(value, index) in traceName" 
            v-bind:key="index"
            :md-label="value"
            :md-editable="false"
            :md-done="true"/>
        </md-steppers> 
    </div>
    -->
    <div class="md-layout">
        <div class="logo" :class="{ 'bordershow': !borderShow }">
            <img src="@/assets/faro2.png" width="179"/>
            <!--
            <div class="saveIcon"> 
                <a href="javascript:;" @click="saveInfo" style="text-decoration: none;">
                <md-icon class="md-size-36">save</md-icon>
                </a>
            </div>
            -->
                
        </div>  


    </div>

    <div class="md-layout int">

        <md-dialog-confirm
        :md-active.sync="showDialog"
            md-title="Aviso"
            md-content="Desea guardar su información."
            md-confirm-text="Si"
            md-cancel-text="No"
            @md-cancel="onCancel"
            @md-confirm="onConfirm" />

        <div class="md-layout-item">
            <div v-for="(value, index) in history" v-bind:key="index" :id="value.id">
                <component v-if="value.show == true" 
                :title="title" :is="index" 
                @setDone="setDoneRoot" 
                @setBack="setBackRoot" 
                @setSaveForm="setSaveFormRoot"
                @downloadFile="downloadFile"
                :complete="complete"
                :pais="pais"
                :data="data"
                :isDisabled="isDisabled"/>          
            </div>
        
        </div>
    </div>  
</div>    
</template>

<script>
import {
    Item000,
    Item1,
    Item2,
    Item3,
    Item4,
    Item5,
    Item6,
    Item7,
    Item8,
    Item9,
    Item10,
    Item11,
    Item111,
    Item112,
    Item113,
    Item12,
    Item13,
    Item14,
    Item15,
    Item16,
    Item17,
    Item18,
    Item19,
    Item20,
    Item21,
    Item30,
} from "./index";
import eventBus from '../bus'
import pais from '../json/pais.json'

export default {
    name:"HomeParticipeView",
    data: () => ({  
      active: '000',
      preview: null,
      enviar:false,
      history:{},
      traceName:[],
      trace:null,
      title:null,  
      complete:0,
      pais:[],
      borderShow: true,
      lastScrollPosition: 0, 
      showDialog:false,
      dataTemp:null,
      isDisabled: true
    }),
    props: {
        data: Object,
    }, 
    async mounted(){
        await this.Init()
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods:{
        async Init(){
            this.title = this.data.name == "Participe" ? "Titular" : "Mancomuno";
            this.history = this.$store.state.historyParticipe
            this.history["item000"].show = false
            
            this.traceName = this.$store.state.traceName
            this.preview = this.active
            this.$store.dispatch("tipo", {tipo:"P", active: this.active});
            eventBus.$emit('isLoading', true);

            //await this.$store.dispatch("loadFondos")

            var that = this
            that.pais = pais;
            window.addEventListener('scroll', this.onScroll)
            
            await this.$store.dispatch("loadFormulario", this.$route.params.id.toString())
            .then((response)=>{
                if(typeof(that.$route.params.view) === 'undefined'){
                    that.active = response.active
                }else{
                    if(that.$route.params.view == "promotor"){
                        
                        that.trace =JSON.parse(response.trace)
                        that.active = that.trace[0].toString();
                        
                    }else{
                    that.active = response.active 
                    }
                }
                
                that.complete = response.complete
                eventBus.$emit('isLoading', false);
                this.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                this.$router.push({name:"NotFound"})
                this.activeComponent()
            });            
        },
        scrollTop(){
            window.scrollTo(0, 0);            
        },
        onScroll () {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                return
            }
            this.borderShow = currentScrollPosition < this.lastScrollPosition
            this.lastScrollPosition = currentScrollPosition
        },        
        setDoneRoot(p){
            this.setDoneForm(p)
            this.activeComponent()
        },        
        setDoneForm(p){
            this.preview = p.id;
            
            this.history["item"+p.id].enviado = true

            if (p.index) {
                this.active = p.index
            }

            this.$store.dispatch("tipo", {tipo:"P", active: this.active});

            this.scrollTop()
        },        
        setBackRoot(p){
            var form = p.id.toLowerCase();

            const findActive = (element) => element == this.active;
            const index = this.trace.findIndex(findActive)
            var pre = "1"

            if(index != 0){
                pre = this.trace[index - 1]
            }
            this.preview = pre
            var x = this.preview;

            this.history[form].enviado = false
            this.history[form].show = false;

            this.active = x;
            eventBus.$emit('isLoading', true);
            this.activeComponent()
            this.scrollTop()
            eventBus.$emit('isLoading', false);
    
        },             
        setSaveFormRoot(p){
            /*
            this.active = p.index;
            this.preview = p.id
            eventBus.$emit('isLoading', true);
            this.activeComponent()
            this.updateFormulario(p)
            this.scrollTop()
            eventBus.$emit('isLoading', false);
            */
            
            eventBus.$emit('isLoading', true);
            this.updateFormulario(p)
            this.next()
            this.scrollTop()
            this.activeComponent()
            eventBus.$emit('isLoading', false);
            
        },   
        activeComponent(){
            this.inactiveComponent()
            this.history["item"+this.preview].show = false;
            this.history["item"+this.active].show = true;
            //this.traceName = this.$store.state.traceName; 
        },
        inactiveComponent(){
            this.$store.dispatch("hideAllComponent");
        },
        downloadFile(item){
            var data = {
                id: this.$route.params.id,
                type: this.data.name,
                item: item.item.toLowerCase(),
                campo: item.campo.toLowerCase()
            };
            var config = {
                method: 'post',
                url: 'https://'+this.$store.state.url+':5001/api/Util/DownloadFile',
                data : data,
                responseType: 'blob'
            };
            var that = this;
            that.$axios(config)
            .then(function (response) {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                
                var file = that.$store.state.item[data.item][data.campo].toString()
                
                fileLink.setAttribute('download', file);
                document.body.appendChild(fileLink);
                
                fileLink.click();
                
            })
            .catch(function () {
                that.$router.push({name:"Error"})
            })
            
        },
        updateFormulario(p){
            this.$store.dispatch("itemUpdate", {
                form:p, 
                ide: this.$route.params.id.toString(), 
                complete: 2
            });
        },

        onConfirm () {
            this.value = 'Agreed'
            var that = this;

            that.updateFormulario(that.dataTemp);

            return this.$store.dispatch("saveFormulario", {
                form:null, 
                ide: this.$route.params.id.toString(), 
                complete: 1,
                user:this.$route.params.pro.toString()
            })            
            .then(() =>{
                
                this.next();
                this.scrollTop()
                eventBus.$emit('isLoading', false);
                that.activeComponent()
            })
            .catch(()=>{
                eventBus.$emit('isLoading', false);
                that.$router.push({name:"Error"})
            })
        },
        next(){
            const findActive = (element) => element == this.active;
            const index = this.trace.findIndex(findActive)
            var pre = this.trace[index + 1]
            if(typeof(pre)==="undefined"){
                pre = "30"
            }
            this.setDoneForm({id: this.active, index: pre})
            
        },
        onCancel () {
            this.value = 'Disagreed'
            eventBus.$emit('buttonDisabled', false);
        },
        saveInfo(){
            this.showDialog = true
        }             
    },
    created(){
        var that = this
        eventBus.$on('saveandContinous',(data)=>{
            that.dataTemp = data
            eventBus.$emit('buttonDisabled', true);
            that.saveInfo()
        })
    },
    computed:{
        elementStepper: function(){
            if(this.traceName.length == 0){
                return false
            }
            return true
        }
    },
    async beforeRouteUpdate(to, from, next) {
        await window.location.reload()
        await next()
    }, 
    components:{    
        Item000,
        Item1,
        Item2,
        Item3,
        Item4,
        Item5,
        Item6,
        Item7,
        Item8,
        Item9,
        Item10,
        Item11,
        Item111,
        Item112,
        Item113,
        Item12,
        Item13,
        Item14,
        Item15,
        Item16,
        Item17,
        Item18,
        Item19,
        Item20,
        Item21,
        Item30,
    }
}
</script>

<style>

</style>